// =============================================================================
// 표준 응답 / 에러 envelope (BE↔FE 공유 타입)
//
// docs/designs/response-envelope.md (M.2) + docs/designs/error-format.md (M.3)
// 의 실현 타입.
//
// success envelope:  { data, meta? }
// error envelope:    { error: { code, message, details?, traceId? } }
//
// 빈 응답 (204) 은 envelope 미적용 — body 자체가 없다.
//
// 본 라운드 (R4.B.2/3) 의 적용 범위:
//   - BE: ResponseEnvelopeInterceptor 가 controller 반환값을 자동 wrap.
//         HttpExceptionFilter 가 모든 4xx/5xx 를 ApiErrorResponse 로 변환.
//   - FE: axios response 인터셉터가 success → unwrap, error → ApiClientError reject.
//
// 특수 처리:
//   - controller 가 이미 envelope 형상 (`'data' in value` 또는 `'error' in value`) 을
//     반환하면 인터셉터는 그대로 통과시킨다 (점진 마이그레이션 안전망).
//   - controller 가 `{ items, total, page, pageSize }` 형상을 반환하면 인터셉터가
//     `{ data: items, meta: PaginationMeta }` 로 자동 변환한다 (BC 호환층).
//   - 그 외는 단순 `{ data: <value> }` wrap.
//
// 본 파일은 BE / FE 양쪽에서 동일하게 import 되므로 NestJS / Vue / axios 등
// 어떤 런타임 의존성도 가지지 않는다.
// =============================================================================
// -----------------------------------------------------------------------------
// Type guards (BE/FE 공용)
// -----------------------------------------------------------------------------
/** 응답 body 가 success envelope 인지 검사. */
export function isApiSuccess(value) {
    return typeof value === 'object' && value !== null && 'data' in value && !('error' in value);
}
/** 응답 body 가 error envelope 인지 검사. */
export function isApiErrorResponse(value) {
    if (typeof value !== 'object' || value === null || !('error' in value)) {
        return false;
    }
    const err = value.error;
    if (typeof err !== 'object' || err === null)
        return false;
    const code = err.code;
    return typeof code === 'string';
}
//# sourceMappingURL=api-envelope.js.map